import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useIntl, defineMessages } from "react-intl";
import axios from "axios";
import { useSnackbar } from "notistack";
import cn from "classnames";
import injectSheet from "react-jss";
import { connect, useSelector } from "react-redux";
import { compose } from "recompose";
import styled from "styled-components";

import { AjaxBlackout, createSnackbar } from "../../../../../_common";
import DialogNovoEmail from "../../_common/DialogNovoEmail";
import DrawerAtividadeEmMassa from "../../_common/DrawerAtividadeEmMassa";
import DrawerAtividadeIndividual from "../../_common/DrawerAtividadeIndividual";
import ModalAtividadeIndisponivel from "../../_common/ModalAtividadeIndisponivel";

const TELA_GRANDE = 1920;
const TELA_MEDIA = 1440;

const style = () => ({
  rootDialogLG: { right: 600 },
  rootDialogMD: { right: 500 },
  rootDialogSM: { right: 400 },
  containerGaveta: {
    height: "100%",
    padding: 24,
  },
  gavetaLG: {
    width: 600,
  },
  gavetaMD: {
    width: 500,
  },
  gavetaSM: {
    width: 400,
  },
  tituloLG: {
    fontSize: 34,
  },
  tituloMD: {
    fontSize: 26,
  },
  tituloSM: {
    fontSize: 18,
  },
  "@global": {
    "*::-webkit-scrollbar": {
      width: "0.4em",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
    },
  },
});

export const EditorEmailStyle = styled.div`
  #campoMensagem {
    min-height: 400px !important;
  }
`;

export const messages = defineMessages({
  sucessoCallbackEnvio: { defaultMessage: "Atividade(s) concluída(s) com sucesso" },
});
function ModalExecutarAtividades({
  classes,
  aberto,
  abertoDrawerAtividade,
  onClose,
  atividades,
  responderEmail = null,
  openModalAtividadeIndisponivel,
  setOpenModalAtividadeIndisponivel,
  isEnvioWhatsApp,
  urlCallbackEnvio = "/api/pipeline/atividade/ProcessarExecucao",
  mensagemSucessoCallbackEnvio = messages.sucessoCallbackEnvio,
}) {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [enviarTodosContatos, setEnviarTodosContatos] = useState(false);
  const [abrirModalTemplates, setAbrirModalTemplates] = useState(false);
  const [reloadContatos, setReloadContatos] = useState(false);
  const [templateSelecionado, setTemplateSelecionado] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cssDrawer, setCssDrawer] = useState(cn(classes.containerGaveta, classes.gavetaLG));
  const [cssRootDialog, setCssRootDialog] = useState(classes.rootDialogLG);
  const [cssTitulo, setCssTitulo] = useState(classes.tituloLG);
  const [contatosId, setContatosId] = useState([]);
  const [isContatosValid, setIsContatosValid] = useState(true);
  const isExecucaoIndividual = atividades.length === 1;

  const handleAlterarEnviarTodosContatos = value => {
    setReloadContatos(true);
    setEnviarTodosContatos(value);

    const timer = setTimeout(() => setReloadContatos(false), 1500);
    return () => {
      clearTimeout(timer);
    };
  };

  const handleExibirTemplate = () => {
    setAbrirModalTemplates(true);
  };

  const handleSelecionarTemplate = item => {
    setIsLoading(true);
    setTemplateSelecionado(item);
    setAbrirModalTemplates(false);
  };

  useEffect(
    () => {
      if (isLoading) {
        setIsLoading(false);
      }
    },
    [isLoading, templateSelecionado]
  );

  const validarEmail = email => {
    let semErros = true;
    if (email.subject === "") {
      enqueueSnackbar(intl.formatMessage({ defaultMessage: "É necessário informar um assunto ao e-mail" }), {
        variant: "info",
      });
      semErros = false;
    }
    if (email.body === "<br>") {
      enqueueSnackbar(intl.formatMessage({ defaultMessage: "É necessário informar o corpo do e-mail" }), {
        variant: "info",
      });
      semErros = false;
    }
    return semErros;
  };

  const emailCentral = useSelector(state => state.emails.usuarioLogado.email);

  const callbackEnvio = email => {
    AjaxBlackout.Show();
    if (isExecucaoIndividual && !contatosId?.length) {
      setIsContatosValid(false);
      AjaxBlackout.Hide();
      return;
    }

    if (validarEmail(email)) {
      try {
        const dadosEnvio = {
          enviarTodosContatos,
          atividades,
          email,
          emailCentral,
          contatosId,
        };
        axios.post(urlCallbackEnvio, dadosEnvio).then(resp => {
          if (resp) {
            createSnackbar(intl.formatMessage(mensagemSucessoCallbackEnvio));
            document.dispatchEvent(new Event("atividades/lista/callback/executarAtividades"));
            AjaxBlackout.Hide();
            onClose();
          }
        });
        setIsContatosValid(true);
      } catch (e) {
        createSnackbar(intl.formatMessage({ defaultMessage: "Não foi possível realizar o envio" }));
        AjaxBlackout.Hide();
        onClose();
      }
    } else {
      AjaxBlackout.Hide();
    }
  };

  const recuperarTemplateAtividade = () => {
    const templatesAtividades = [...new Set(atividades?.map(item => item.templateEmailId))];
    if (templatesAtividades.length === 1) setTemplateSelecionado(templatesAtividades[0]);
    else setTemplateSelecionado(null);
  };

  useEffect(
    () => {
      setIsLoading(false);
    },
    [templateSelecionado]
  );

  useEffect(() => {
    handleResize();
  }, []);

  useEffect(() => {
    recuperarTemplateAtividade();
    if (!isExecucaoIndividual && !enviarTodosContatos) {
      const contatosIdPrincipais = atividades.flatMap(atividade =>
        atividade.lead?.contatosLead.filter(contato => contato.principal).map(contato => contato.id)
      );
      setContatosId(contatosIdPrincipais);
    }
  }, []);

  const handleResize = () => {
    if (window.innerWidth >= TELA_GRANDE) {
      setCssDrawer(cn(classes.containerGaveta, classes.gavetaLG));
      setCssRootDialog(classes.rootDialogLG);
      setCssTitulo(classes.tituloLG);
    } else if (window.innerWidth >= TELA_MEDIA) {
      setCssDrawer(cn(classes.containerGaveta, classes.gavetaMD));
      setCssRootDialog(classes.rootDialogMD);
      setCssTitulo(classes.tituloMD);
    } else {
      setCssDrawer(cn(classes.containerGaveta, classes.gavetaSM));
      setCssRootDialog(classes.rootDialogSM);
      setCssTitulo(classes.tituloSM);
    }
  };

  window.addEventListener("resize", handleResize);

  const handleCloseModalAtividadeIndisponivel = () => {
    setOpenModalAtividadeIndisponivel(false);
    document.dispatchEvent(new Event("atividades/lista/callback/executarAtividades"));
  };

  return (
    <>
      {atividades.length === 1 ? (
        <DrawerAtividadeIndividual
          aberto={aberto || abertoDrawerAtividade}
          enviarTodosContatos={enviarTodosContatos}
          atividade={atividades[0]}
          reloadContatos={reloadContatos}
          onClose={onClose}
          cssDrawer={cssDrawer}
        />
      ) : (
        <DrawerAtividadeEmMassa
          aberto={aberto || abertoDrawerAtividade}
          enviarTodosContatos={enviarTodosContatos}
          atividades={atividades}
          reloadContatos={reloadContatos}
          onClose={onClose}
          cssDrawer={cssDrawer}
          cssTitulo={cssTitulo}
          isEnvioWhatsApp={isEnvioWhatsApp}
        />
      )}

      <DialogNovoEmail
        cssRootDialog={cssRootDialog}
        aberto={aberto}
        enviarTodosContatos={enviarTodosContatos}
        handleAlterarEnviarTodosContatos={handleAlterarEnviarTodosContatos}
        isLoading={isLoading}
        templateSelecionado={templateSelecionado}
        handleExibirTemplate={handleExibirTemplate}
        responderEmail={responderEmail}
        callbackEnvio={callbackEnvio}
        abrirModalTemplates={abrirModalTemplates}
        handleSelecionarTemplate={handleSelecionarTemplate}
        atividades={atividades}
        setContatosId={setContatosId}
        isContatosValid={isContatosValid}
        setIsContatosValid={setIsContatosValid}
      />

      <ModalAtividadeIndisponivel
        open={openModalAtividadeIndisponivel}
        onClose={handleCloseModalAtividadeIndisponivel}
      />
    </>
  );
}

ModalExecutarAtividades.propTypes = {
  aberto: PropTypes.bool,
  abertoDrawerAtividade: PropTypes.bool,
  onClose: PropTypes.func,
  atividades: PropTypes.array,
  responderEmail: PropTypes.object,
  openModalAtividadeIndisponivel: PropTypes.bool,
  setOpenModalAtividadeIndisponivel: PropTypes.func,
  isEnvioWhatsApp: PropTypes.bool,
  urlCallbackEnvio: PropTypes.string,
  mensagemSucessoCallbackEnvio: PropTypes.object,
};

const mapStateToProps = state => ({
  responderEmail: state.emails.responderEmail,
});

const enhance = compose(
  injectSheet(style),
  connect(mapStateToProps)
);

export default enhance(ModalExecutarAtividades);
